import {BillingCycle, BillingCycles, PlanKind, PlanKinds, PlanType, PlanTypes} from "@/app/lib/pricing/types";
import {
    ElectronicSubscriptionName,
    FoundationPlanMonthlyPrice,
    FoundationPlanName,
    FoundationPlanYearlyPrice,
    FoundationPlusPlanMonthlyPrice,
    FoundationPlusPlanYearlyPrice,
    MonthlySubscriptionName,
    ProPlanMonthlyPrice,
    ProPlanName,
    ProPlanYearlyPrice,
    ProPlusPlanMonthlyPrice,
    ProPlusPlanYearlyPrice,
    YearlySubscriptionName
} from "@/app/lib/pricing/const";

export function getPlanDetails(
    plan: PlanType,
    kind: PlanKind,
    billing: BillingCycle) {
    const billingName = billing === BillingCycles.monthly ? MonthlySubscriptionName : YearlySubscriptionName;
    let planName = '';
    let price = 0;
    if (plan === PlanTypes.foundation) {
        planName = FoundationPlanName;
        if (kind === PlanKinds.acoustic) {
            price = billing === BillingCycles.monthly ? FoundationPlanMonthlyPrice : FoundationPlanYearlyPrice;
        } else {
            price = billing === BillingCycles.monthly ? FoundationPlusPlanMonthlyPrice : FoundationPlusPlanYearlyPrice;
        }
    } else if (plan === PlanTypes.pro) {
        planName = ProPlanName;
        if (kind === PlanKinds.acoustic) {
            price = billing === BillingCycles.monthly ? ProPlanMonthlyPrice : ProPlanYearlyPrice;
        } else {
            price = billing === BillingCycles.monthly ? ProPlusPlanMonthlyPrice : ProPlusPlanYearlyPrice;
        }
    } else {
        throw new Error('Invalid pricing plan type');
    }

    const priceText = price.toFixed(2);
    const priceParts = priceText.split('.');
    const priceWhole = priceParts[0];
    const priceFraction = priceParts[1];

    return {
        planName,
        billingName,
        fullName: `${planName}${kind === PlanKinds.electronic ?  ' ' + ElectronicSubscriptionName : ''} ${billingName}`,
        price,
        formattedPrice: priceText,
        priceWhole,
        priceFraction,
    };
}

export function pricingStat(num: number): string {
    if (num < 1000) {
        return Math.trunc(num / 10) * 10 + '+';
    }
    if (num < 10000) {
        return (Math.trunc(num / 100) * 100).toLocaleString(undefined, {useGrouping: true}) + '+';
    }
    return (Math.trunc(num / 1000) * 1000).toLocaleString(undefined, {useGrouping: true}) + '+';
}
